module.exports = __webpack_public_path__ + "img/ball-material.cf75ec41.png";